import { CiAdvancedSingleChoice } from '../../../../../ui/icons-custom/IconsCustom.tsx';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule.ts';
import { RequiredRule } from '../../../../rules/repository/required/Required.rule.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema.ts';
import { OptionsTranslationSchema } from '../../translations/OptionsTranslationSchema.ts';
import { AdvancedSelectWidgetPreview } from '../advanced-select-common/AdvancedSelectWidgetPreview.tsx';
import { AdvancedSingleSelectWidgetComponent } from './AdvancedSingleSelectWidgetComponent.tsx';
import {
  AdvancedSingleSelectWidgetConfigComponent,
  AdvancedSingleSelectWidgetConfigSchema,
} from './AdvancedSingleSelectWidgetConfigComponent.tsx';
import { createAdvancedSingleSelectFormSchema } from './createAdvancedSingleSelectFormSchema.ts';
import {
  getAdvancedSingleSelectColumnsReferences,
  getAdvancedSingleSelectMainReference,
} from './getAdvancedSingleSelectWidgetReferences.ts';
import { hydrateAdvancedSingleSelectWidget } from './hydrateAdvancedSingleSelectWidget.ts';
import { type IAdvancedSingleSelectWidget } from './IAdvancedSingleSelectWidget.ts';

/**
 * Tipo del widget di selezione singola avanzata.
 */
export const AdvancedSingleSelectWidgetType: IWidgetType<IAdvancedSingleSelectWidget> =
  {
    type: WidgetType.AdvancedSelect,
    mainType: WidgetMainType.Input,
    category: WidgetCategory.Input,
    name: 'Campo scelta singola avanzata',
    icon: <CiAdvancedSingleChoice />,
    hasValue: true,
    getReference: getAdvancedSingleSelectMainReference,
    getSiblingReferences: getAdvancedSingleSelectColumnsReferences,
    hydrate: hydrateAdvancedSingleSelectWidget,
    formComponent: AdvancedSingleSelectWidgetComponent,
    createFormSchema: createAdvancedSingleSelectFormSchema,
    previewComponent: AdvancedSelectWidgetPreview,
    configValidator: AdvancedSingleSelectWidgetConfigSchema,
    configComponent: AdvancedSingleSelectWidgetConfigComponent,
    translationSchema: tran.widget({
      ...InputCommonTranslationSchema.objectShape,
      options: OptionsTranslationSchema,
      buttonText: tran.string(),
      buttonTextAfter: tran.string(),
      cancelButtonText: tran.string(),
    }),
    rules: [RequiredRule, CustomWarningsRule],
  };
